import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import AOS from 'aos';

export default function HomeBooks() {
  const [latestBooks, setLatestBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopBooks = async () => {
      try {
        const res = await fetch('https://sanjaydhir.com/api/books');
        const data = await res.json();

        if (Array.isArray(data)) {
          // Sort descending by numerical/string year and slice top 3
          const sorted = data
            .sort((a, b) => parseInt(b.year || 0) - parseInt(a.year || 0))
            .slice(0, 3);
          setLatestBooks(sorted);
        }
      } catch (err) {
        console.error('Failed to load books:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopBooks();
  }, []);

  useEffect(() => {
    if (!loading && latestBooks.length > 0) {
      setTimeout(() => {
        AOS.refreshHard();
      }, 150);
    }
  }, [loading, latestBooks]);

  return (
    <section className="container py-5 my-3 text-light">
      <div className="text-center mb-5" data-aos="fade-up">
        <h2 className="fw-bold text-gradient display-6">Featured Books & Publications</h2>
        <p className="text-secondary mx-auto" style={{ maxWidth: '650px' }}>
          Explore key authored books on Strategic Management, Innovation Systems, and Emerging Markets.
        </p>
      </div>

      {loading ? (
        <div className="text-center text-secondary py-4">Loading featured publications...</div>
      ) : latestBooks.length === 0 ? (
        <div className="text-center text-secondary py-4">No books currently listed.</div>
      ) : (
        <div className="row g-4 justify-content-center mb-4">
          {latestBooks.map((book, idx) => {
            const cover =
              book.coverImage ||
              'https://via.placeholder.com/350x500/1e293b/38bdf8?text=Book+Cover';

            return (
              <div
                key={book._id}
                className="col-12 col-md-6 col-lg-4"
                data-aos="fade-up"
                data-aos-delay={idx * 150}
              >
                <div
                  className="card h-100 bg-dark text-light border-secondary shadow-sm d-flex flex-column overflow-hidden"
                  style={{
                    borderRadius: '12px',
                    transition: 'transform 0.25s ease, border-color 0.25s ease',
                    background: 'linear-gradient(180deg, #111827 0%, #0b0f19 100%)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = '#38bdf8';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = '#4b5563';
                  }}
                >
                  {/* Book Cover Container */}
                  <div
                    style={{
                      height: '240px',
                      width: '100%',
                      background: '#090d16',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      padding: '12px',
                    }}
                  >
                    <img
                      src={cover}
                      alt={book.title}
                      style={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        objectFit: 'contain',
                        borderRadius: '4px',
                        boxShadow: '0 6px 14px rgba(0,0,0,0.5)',
                      }}
                      onError={(e) => {
                        e.target.src =
                          'https://via.placeholder.com/350x500/1e293b/38bdf8?text=No+Cover';
                      }}
                    />
                  </div>

                  {/* Card Content */}
                  <div className="card-body d-flex flex-column p-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="badge bg-info bg-opacity-10 text-info border border-info border-opacity-25 px-2 py-1">
                        Year: {book.year}
                      </span>
                      {book.isbn && (
                        <span className="text-secondary small">ISBN: {book.isbn}</span>
                      )}
                    </div>

                    <h5
                      className="card-title text-white fw-bold mb-1"
                      style={{
                        fontSize: '1.05rem',
                        lineHeight: '1.4',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        minHeight: '2.8rem',
                      }}
                    >
                      {book.title}
                    </h5>

                    <p className="text-info small mb-1">{book.authors}</p>
                    <p className="text-secondary small mb-3">
                      <em>{book.publisher}</em>
                    </p>

                    {book.description && (
                      <div
                        className="text-secondary small mb-3 flex-grow-1"
                        style={{
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          lineHeight: '1.5',
                        }}
                      >
                        {book.description}
                      </div>
                    )}

                    {book.buyLink && (
                      <a
                        href={book.buyLink}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-warning w-100 rounded-pill mt-auto"
                      >
                        Publisher Details ↗
                      </a>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Button to View Full Books Page */}
      <div className="row justify-content-center mt-2">
        <div className="col-12 col-md-6 col-lg-4">
          <NavLink
            to="/Research/Books"
            onClick={() => window.scrollTo(0, 0)}
            className="btn w-100 btn-outline-warning py-2 btn-hover-pop text-center"
          >
            View All Books
          </NavLink>
        </div>
      </div>
    </section>
  );
}